'use client';
import { useEffect } from 'react';
import ContentstackLivePreview from '@contentstack/live-preview-utils';

export default function LivePreviewInitComponent() {
  const enabled = process.env.NEXT_PUBLIC_CS_LIVE_PREVIEW === 'true';

  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return;

    ContentstackLivePreview.init({
      enable: enabled,
      mode: 'preview',
      ssr: true,
      stackDetails: {
        apiKey: process.env.NEXT_PUBLIC_CS_DELIVERY_API_KEY,
        environment: process.env.NEXT_PUBLIC_CS_ENVIRONMENT,
        branch: 'main'
      },
      editButton: { enable: false },
      clientUrlParams: {
        protocol: 'https',
        host: 'app.contentstack.com',
        port: 443
      }
    });
  }, [enabled]); // run once on mount, re-run only if enabled flips

  return null;
}
